/**
 * How long the picker's search input waits after a keystroke before it
 * searches.
 */
export const SEARCH_DEBOUNCE_MS = 300;

export const DATA_APPS_ROOT_ID = "data-apps";
